import './App.css';
import './pro-theme.css';
import './rtl-layout.css';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "./config";

import Navbar from "./components/Navbar";
import Home from "./components/Homes";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Blog from './components/Blog';
import About_me from './components/About_me';
import Portfolio from './components/Portfolio';
import PorDetail from './components/PorDetail';
import OtherSites from './components/OtherSites';
import MetaTags from './MetaTags';
import View from './components/View';
import LanguageWelcomeModal from "./components/LanguageWelcomeModal";

// Composant pour compter les vues d'une page
const PageViews = ({ pageId }) => {
  useEffect(() => {
    axios
      .post(`${API_URL}/api/view/${pageId}`)
      .catch((err) => console.error(err));
  }, [pageId]);
  return null;
};

// Wrapper pour les routes qui gère automatiquement le compteur
const RouteWithViews = ({ element: Element }) => {
  const location = useLocation();
  // Un seul segment d’URL pour /api/view/:pageId (Express). Ex. /portfolioDetails/5 → portfolioDetails_5
  const raw = location.pathname.replace(/^\/+/, "") || "home";
  const pageId = raw.replace(/\//g, "_");

  return (
    <div>
      <PageViews pageId={pageId} />
      <Element />
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="App portfolio-pro">
        <LanguageWelcomeModal />
        <MetaTags />
        <Navbar />
        <Routes>
          <Route path="/" element={<RouteWithViews element={Home} />} />
          <Route path="/contact" element={<RouteWithViews element={Contact} />} />
          <Route path="/blog" element={<RouteWithViews element={Blog} />} />
          <Route path="/about" element={<RouteWithViews element={About_me} />} />
          <Route path="/portfolio" element={<RouteWithViews element={Portfolio} />} />
          <Route path="/portfolioDetails/:id" element={<RouteWithViews element={PorDetail} />} />
          <Route path="/othersites" element={<RouteWithViews element={OtherSites} />} />
          {/* Nouvelle page pour voir toutes les vues */}
          <Route path="/viewKanLiyaAna" element={<View />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
